import {texture} from "p3";
import definitions from "../../../definitions";
import NPC from "./NPC";

export default class NPCGoblin extends NPC {
    constructor() {
        super(definitions.NPC_ID.GOBLIN);

        this.collisionRadius = 30;
        this.collisionOffsetX = -2;
        this.collisionOffsetY = -34;
    }

    init() {
        super.init();
        
        this.addViewWithTexture(texture("char_goblin_idle_00"));

        this.addShadow(definitions.SHADOW_SIZE.MEDIUM, 1, new PIXI.Point(-15, -8));
        this.animateIdle(0.5);
    }
}